DOMReady( function(){
  /* ========================================================================
  * formulaire jeux
  * ======================================================================== */
  if( document.querySelector('.form-game'))
  {

    [... document.querySelectorAll('.form-game .game')].map( elt => {
      elt.addEventListener('change', function(e){
        e.preventDefault();

        let forces = JSON.parse(elt.querySelector('option:checked').dataset.force);

        if(forces.length > 0)
        {
          document.querySelector(".form-game #form-force").style.display = 'block';

          [... document.querySelectorAll('.form-game .force')].map( select => {
            select.innerHTML = '';

            let options = '';
            forces.forEach(row => {
              options +="<option value='"+row.url+"'>"+row.name+"</option>";
            });

            select.innerHTML = options;
          });
        }
        else{
          document.querySelector(".form-game .force").innerHTML = '';
          document.querySelector(".form-game #form-force").style.display = 'none';
        }

      });

    });

    [... document.querySelectorAll('.form-game .btn')].map( elt => {
        elt.addEventListener('click', function(e){
          e.preventDefault();
          if(document.querySelector(".form-game .force option:checked"))
          {
            location.href = document.querySelector(".form-game .force option:checked").value;
          }
          else if(document.querySelector(".form-game .game option:checked").value != ""){
            location.href = document.querySelector(".form-game .game option:checked").value;
          }

        });
    });
  }
});
